import React from 'react'
import {useSelector} from 'react-redux'
import {IReduxState} from '../../../redux/types/IReduxState'
import QueryResult from '../domain/QueryResult'
import classNames from 'classnames'
import {ResultInTable} from '../components/ResultInTable'

interface IMasterResultProps {
  id: string
}

const MasterResult: React.FC<IMasterResultProps> = (): React.ReactElement => {
  const queryResultUser = useSelector<IReduxState, QueryResult | undefined>((state) => state.task?.queryResultUser)
  const queryResultSolution = useSelector<IReduxState, QueryResult | undefined>(
    (state) => state.task?.queryResultSolution,
  )
  const isQueryResultEquals = useSelector<IReduxState, boolean>((state) => state.task?.isQueryResultEquals)

  const css = classNames(
    'task-bottom-collapsible-block-body',
    'task-result-table',
    'task-result-table-solution',
    isQueryResultEquals ? ' success' : ' error',
    'h-100',
  )

  return (
    <div className={css}>
      <ResultInTable data={queryResultSolution} dataOther={queryResultUser} isUserResult={false} />
    </div>
  )
}

export {MasterResult}
